export default {"src":"/_next/static/media/smile.df5cdb35.svg","height":34,"width":34};